import { render, staticRenderFns } from "./ProjectModalSimple.vue?vue&type=template&id=35320d76&"
import script from "./ProjectModalSimple.vue?vue&type=script&lang=js&"
export * from "./ProjectModalSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports